import './Box.css';
import moment from 'moment'
import React from 'react';
import Tag from './Tag';

class Box extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    // Sort reads by time in descending order (newest first)
    var reads = this.props.box.reads.sort((a, b) => b.time - a.time);

    // Get the first 100 reads of the array, so actually the 100 most recent reads
    var renderedreads = reads.slice(0, 100).map(read => {
      return (
        <Tag key={read.tag+read.time} read={read} />
      );
    });

    // Calculate voltage and temperature bar widths
    const voltageWidth = (parseFloat(this.props.box.volt) / 24) * 100;
    const temperatureWidth = (parseFloat(this.props.box.temp) / 85) * 100;

    return(
      <div className={`Box ${this.props.box.state}`}>
        <div className="title">&#9679; Box {this.props.box.id} ({this.props.box.reads.length} reads)</div>

        <div className="voltage">
          <div>Voltage: {this.props.box.volt} V</div>
          <div className="bar-container">
            <div className="voltage-bar" style={{ width: `${voltageWidth}%` }}></div>
          </div>
        </div>

        <div className="temperature">
          <div>Temperature: {this.props.box.temp} °C</div>
          <div className="bar-container">
            <div className="temperature-bar" style={{ width: `${temperatureWidth}%` }}></div>
          </div>
        </div>

        <div className="status">
          <div>Status Revolution: {this.props.box.revolutionStatus}</div>
        </div>

        <div className="reads">{renderedreads}</div>
      </div>
    );
  }

}

export default Box
